import React from 'react';
import type { MouseEventHandler } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

export type SortLabelProps = {
  /** 标签名称 */
  name?: string;
  /** 标签值 */
  value?: string;
  /** 标签是否选中 */
  selected?: boolean;
  /** 标签未选中icon链接 */
  iconXLinkHref?: string;
  /** 标签选中状态icon链接 */
  selectedIconXLinkHref?: string;
  /** 标签点击后回调 */
  onClick?: (value: string) => void;
  /** 自定义标签样式类 */
  className?: string;
};

const SortLabel: React.FC<SortLabelProps> = ({
  name,
  value,
  selected,
  iconXLinkHref,
  selectedIconXLinkHref,
  onClick,
  className,
}) => {
  const onLabelClick: MouseEventHandler<HTMLSpanElement> = () => {
    onClick?.(value);
  };
  return (
    <span className={classnames(styles.label, selected && styles['label--selected'], className)} onClick={onLabelClick}>
      {name}
      {iconXLinkHref && (
        <svg className={classnames(styles.icon, 'icon')} aria-hidden="true">
          <use
            xlinkHref={
              selected
                ? selectedIconXLinkHref[0] === '#'
                  ? selectedIconXLinkHref
                  : `#${selectedIconXLinkHref}`
                : iconXLinkHref[0] === '#'
                ? iconXLinkHref
                : `#${iconXLinkHref}`
            }
          />
        </svg>
      )}
    </span>
  );
};

export default SortLabel;
